import { Box } from '@mui/material';

import locales from '../../../../../../../constants/locales';

const ExpiredEvents = () => <Box textAlign="center">{locales.billing.details.events.ussdSessionExpired}</Box>;

export default ExpiredEvents;
